import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { UserRole } from '../../helpers/userHelper';
import { agcColours } from '../../helpers/colourHelper';
import * as api from '../../api/base';
import { endpoints } from '../../api/endpoints';
import { setLoading, unsetLoading, resetResponseState } from '../../store/appAction';
import {
    dfltSuccessResponseAction,
    dfltFailResponseAction,
    dfltExceptionResponseAction
} from '../../store/utility'

import PropTypes from 'prop-types';

const AdminButton = (props) => {

    const user = useSelector(state => state.auth.user);

    return (
        UserRole.isAllAdmins(user.role) &&
        <Button
            className="activated"
            variant="contained"
            {...props}
        >
            {props.children}
        </Button>);
};

AdminButton.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default AdminButton;



const closedAlert = { open: false, severity: 'success', mesg: '' }

export const AdminRecalcButton = (adminprops) => {
    const dispatch = useDispatch();
    const { onRecalculated, ...props} = adminprops;

    const [alertState, setAlertState] = useState(closedAlert)
    const { successMsg, errorMsg } = useSelector(state => state.common);
    const reportId = useSelector(state => state.common.reportId);

    const handleClose = () => {
        // need to first close the alert and only 
        // a bit after (300ms) reset the message and severity to avoid 
        // weird effect where an empty alert is shown 
        let close = { ...alertState }
        close.open = false
        setAlertState(close)
        dispatch(resetResponseState());
        dispatch(unsetLoading())
        setTimeout(() => {
            setAlertState(closedAlert)
        }, 300);
    }

    useEffect(() => {
        if (successMsg) {
            setAlertState({ open: true, severity: 'success', mesg: successMsg })
        } else if (errorMsg) {
            setAlertState({ open: true, severity: 'warning', mesg: errorMsg })
        }
    }, [successMsg, errorMsg]);

    const recalculateHandler = async () => {
        dispatch(setLoading());

        let query = { reportId: reportId }
        try {
            const response = await api.get(endpoints.farm.reportCalculate, query);
            if (response?.status === 200) {
                dispatch(dfltSuccessResponseAction("Report recalculation requested"));
                setTimeout(() => {
                    onRecalculated()
                }, 3000);
            }
            else {
                dispatch(dfltFailResponseAction({ status: 500, data: 'Recalculation request failed!' }));
            }

        } catch (e) {
            dispatch(dfltExceptionResponseAction(e));
        }
    }

    return <>
        <AdminButton
            {...props}
            sx={{ ...props.sx, textTransform: 'none', backgroundColor: agcColours.MilanoRed }}
            onClick={recalculateHandler}>
            Recalculate
        </AdminButton>
        <Snackbar open={alertState.open} autoHideDuration={3000} onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
            <Alert
                variant="filled"
                severity={alertState.severity}
                onClose={handleClose}>
                {alertState.mesg}
            </Alert>
        </Snackbar>
    </>
}

AdminRecalcButton.propTypes={
    onRecalculated:PropTypes.func,
    sx: PropTypes.object
}